import { GetSiteTemperatureComfortListResponseSchema } from '@shared/schema/site.temperature-comfort-list.schema'
import { queryOptions } from '@tanstack/react-query'
import { HTTPError } from 'ky'

import { QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

export function temperatureComfortQuery(params: { startDate: string; endDate: string }) {
  return queryOptions({
    queryKey: ['site', 'energy', 'temperature', 'comfort', 'list', params],
    async queryFn() {
      const searchParams = new URLSearchParams({
        startDate: params.startDate,
        endDate: params.endDate,
      })

      try {
        const rawResponse = await apiFetch.get('site/energy/temperature-comfort', { searchParams })

        return await GetSiteTemperatureComfortListResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        if (error instanceof HTTPError) {
          throw error
        } else {
          throw new TypeError('Failed to parse temperature comfort response', { cause: error })
        }
      }
    },
  })
}

export type TemperatureComfort = QueryOptionsData<typeof temperatureComfortQuery>
